import { render, staticRenderFns } from "./PublishLists.vue?vue&type=template&id=9dd7508e&scoped=true"
import script from "./PublishLists.vue?vue&type=script&lang=js"
export * from "./PublishLists.vue?vue&type=script&lang=js"
import style0 from "./PublishLists.vue?vue&type=style&index=0&id=9dd7508e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd7508e",
  null
  
)

export default component.exports